import { render, staticRenderFns } from "./MiniPlayer.vue?vue&type=template&id=0a4536e9&scoped=true&"
import script from "./MiniPlayer.vue?vue&type=script&lang=js&"
export * from "./MiniPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MiniPlayer.vue?vue&type=style&index=0&id=0a4536e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4536e9",
  null
  
)

export default component.exports